// extracted by mini-css-extract-plugin
module.exports = {"AFGCButton":"AFGCButton-module--AFGCButton--2eYkQ","pinkVariant":"AFGCButton-module--pinkVariant--1gUB7"};